export default "__VITE_ASSET__TXSKQpUM__"